import api from '../api'

const initialState = { data: null, networkTimeDiff: 0 };

export const config = {
    namespaced: true,
    state: initialState,
    actions: {

        getConfig({ commit }, cache){
            if((cache == undefined || cache == false) && this.state.data != null) 
                return Promise.resolve(this.state.data);
            
            return api.config().then(function (response) {
                    commit('getConfig', response.data);
                    return Promise.resolve(response.data);
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                    commit('getConfigFailure');
                    return Promise.reject(error);
                });
        },

        setConfig({ commit }, data){
            commit('getConfig', data);
            return Promise.resolve(data);
        }

    },
    mutations: {
        getConfigFailure(state) {
            state.data = null;
        },
        getConfig(state, data) {
            state.data = data;
            let netTime = moment.utc(data.currentDateTime).add(100, 'ms'); // 100 ms is approximate network delay
            state.networkTimeDiff  = netTime - moment.utc();

            // let nt = moment.utc() + state.networkTimeDiff;
            // console.log(moment.utc().format(), moment.utc(nt).format(), state.networkTimeDiff);
        }
    }
};